import { render, staticRenderFns } from "./ExpenseTags.vue?vue&type=template&id=5b451b14&"
import script from "./ExpenseTags.vue?vue&type=script&lang=js&"
export * from "./ExpenseTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports